// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_w-1";
export var movingGradient = "_w-4";
export var movingGradientBlock = "_w-2";
export var skeleton = "_w-0";
export var skeletonText = "_w-3";